<template>
  <div class="page fp-viewing-contest">
    <curtains>
      <fixed-blocks v-if="this.$mq !== 'mobile'"></fixed-blocks>
      <navigation v-if="this.$mq !== 'mobile'"></navigation>
      <fixed-blocks-mobile v-if="this.$mq === 'mobile'">
        <navigation></navigation>
      </fixed-blocks-mobile>
      <h1 class="pageHeader">
        Поздравляем победителей
      </h1>
      <div v-if="this.$mq !== 'mobile'" style="position: relative;z-index: 200;margin-top: 10vh;">
        <div class="container">
          <div class="big">
            <div class="winner">
              <div class="line" @click='redirectToImage(347)' style="cursor: pointer">
                <div class="wrapper">
                  <img src="../assets/images/winners/user_1111246.jpg" alt=""></div>
                <div class="name">Yulia<br>Ilina</div>
              </div>
              <hr>
              <div class="line">
                <div class="icon icon-plane"></div>
                <div class="text">
                  Гастротур на двоих<br>
                  в Бразилию
                </div>
              </div>
            </div>
            <div class="winner">
              <div class="line" @click='redirectToImage(339)' style="cursor: pointer">
                <div class="wrapper">
                  <img src="../assets/images/winners/user_14748665.jpg" alt=""></div>
                <div class="name">Sergei <br>Kiselev</div>
              </div>
              <hr>
              <div class="line">
                <div class="icon icon-phone"></div>
                <div class="text">
                  Телефон X
                </div>
              </div>
            </div>
          </div>
          <div class="normal">
            <div class="winner">
              <div class="line" @click='redirectToImage(238)' style="cursor: pointer">
                <div class="wrapper">
                  <img src="../assets/images/winners/user_79453375.jpg" alt=""></div>
                <div class="name">Pavel<br>Moroz</div>
              </div>
              <hr>
              <div class="line">
                <div class="icon icon-doc"></div>
                <div class="text">
                  Подарочный сертификат <br>
                  на покупку спортивных товаров
                </div>
              </div>
            </div>
            <div class="winner">
              <div class="line" @click='redirectToImage(248)' style="cursor: pointer">
                <div class="wrapper">
                  <img src="../assets/images/winners/user_433408204.jpg" alt=""></div>
                <div class="name">Maria <br>Basipova</div>
              </div>
              <hr>
              <div class="line">
                <div class="icon icon-doc"></div>
                <div class="text">
                  Подарочный сертификат <br>
                  на покупку спортивных товаров
                </div>
              </div>
            </div>
            <div class="winner">
              <div class="line" @click='redirectToImage(266)' style="cursor: pointer">
                <div class="wrapper">
                  <img src="../assets/images/winners/user_435590382.jpg" alt=""></div>
                <div class="name">Denis <br>Krikunov</div>
              </div>
              <hr>
              <div class="line">
                <div class="icon icon-doc"></div>
                <div class="text">
                  Подарочный сертификат <br>
                  на покупку спортивных товаров
                </div>
              </div>
            </div>
            <div class="winner">
              <div class="line" @click='redirectToImage(320)' style="cursor: pointer">
                <div class="wrapper">
                  <img src="../assets/images/winners/user_139746867.jpg" alt=""></div>
                <div class="name">Kristina<br>Lubavskaya</div>
              </div>
              <hr>
              <div class="line">
                <div class="icon icon-doc"></div>
                <div class="text">
                  Подарочный сертификат <br>
                  на покупку спортивных товаров
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div v-if="this.$mq === 'mobile'">
        <swiper ref="mySwiper" :options="swiperOption">
          <swiper-slide>
            <div class="big">
              <div class="winner">
                <div class="line" @click='redirectToImage(347)' style="cursor: pointer">
                  <div class="wrapper">
                    <img src="../assets/images/winners/user_1111246.jpg" alt=""></div>
                  <div class="name">Yulia<br>Ilina</div>
                </div>
                <hr>
                <div class="line">
                  <div class="icon icon-plane"></div>
                  <div class="text">
                    Гастротур на двоих<br>
                    в Бразилию
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="big">
              <div class="winner">
                <div class="line" @click='redirectToImage(339)' style="cursor: pointer">
                  <div class="wrapper">
                    <img src="../assets/images/winners/user_14748665.jpg" alt=""></div>
                  <div class="name">Sergei <br>Kiselev</div>
                </div>
                <hr>
                <div class="line">
                  <div class="icon icon-phone"></div>
                  <div class="text">
                    Телефон X
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="normal">
              <div class="winner">
                <div class="line" @click='redirectToImage(238)' style="cursor: pointer">
                  <div class="wrapper">
                    <img src="../assets/images/winners/user_79453375.jpg" alt=""></div>
                  <div class="name">Pavel<br>Moroz</div>
                </div>
                <hr>
                <div class="line">
                  <div class="icon icon-doc"></div>
                  <div class="text">
                    Подарочный сертификат <br>
                    на покупку спортивных товаров
                  </div>
                </div>
              </div>

            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="normal">
              <div class="winner">
                <div class="line" @click='redirectToImage(248)' style="cursor: pointer">
                  <div class="wrapper">
                    <img src="../assets/images/winners/user_433408204.jpg" alt=""></div>
                  <div class="name">Maria <br>Basipova</div>
                </div>
                <hr>
                <div class="line">
                  <div class="icon icon-doc"></div>
                  <div class="text">
                    Подарочный сертификат <br>
                    на покупку спортивных товаров
                  </div>
                </div>
              </div>

            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="normal">

              <div class="winner">
                <div class="line" @click='redirectToImage(266)' style="cursor: pointer">
                  <div class="wrapper">
                    <img src="../assets/images/winners/user_435590382.jpg" alt=""></div>
                  <div class="name">Denis <br>Krikunov</div>
                </div>
                <hr>
                <div class="line">
                  <div class="icon icon-doc"></div>
                  <div class="text">
                    Подарочный сертификат <br>
                    на покупку спортивных товаров
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="normal">

              <div class="winner">
                <div class="line" @click='redirectToImage(320)' style="cursor: pointer">
                  <div class="wrapper">
                    <img src="../assets/images/winners/user_139746867.jpg" alt=""></div>
                  <div class="name">Kristina<br>Lubavskaya</div>
                </div>
                <hr>
                <div class="line">
                  <div class="icon icon-doc"></div>
                  <div class="text">
                    Подарочный сертификат <br>
                    на покупку спортивных товаров
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>


          <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        </swiper>
      </div>
    </curtains>
  </div>
</template>

<script>
    import EventBus from '../event-bus.js';
    import Navigation from '../components/common/Navigation.vue';
    import axios from 'axios';
    import VueGallery from 'vue-gallery';
    import Curtains from '../components/common/Curtains';
    import fixedBlocks from '../components/common/fixedBlocks';
    import fixedBlocksMobile from '../components/common/fixedBlocksMobile';
    import {swiper, swiperSlide} from 'vue-awesome-swiper'

    export default {
        name: "Winners",
        metaInfo: {
            title: 'Победители',
        },
        components: {
            Navigation,
            Curtains,
            fixedBlocks,
            fixedBlocksMobile,
            swiper,
            swiperSlide

        },
        computed: {
            swiper() {
                return (this.$refs.mySwiper)?this.$refs.mySwiper.swiper: null;
            }
        },
        data() {
            return {
                swiperOption: {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination'
                    }
                },

            }
        },
        mounted() {
            let id = this.$route.params.id;
            if (id){
                this.swiper.slideTo(id);
            }
        },
        methods: {
            redirectToImage(id) {
                this.$router.push({name: 'gallery', params: {id: id, winner: (this.swiper)? this.swiper.activeIndex: null}})
            }
        }
    }
</script>

<style scoped lang="scss">
  @import "../assets/scss/mixins";

  .page {
    display: block;
    width: 100%;
    min-height: 100vh;
    height: 100%;
    position: relative;
    background: #0d8987;
    overflow: auto;
  }

  .pageHeader {
    color: #ffffff;
    font-size: 60px;
    font-weight: 700;
    line-height: 89px;
    text-align: center;
    margin: 55px auto 26px;
    position: relative;
    z-index: 200;

    @include breakpoint(mobile) {
      font-size: 30px;
      font-weight: 700;
      line-height: 38px;
      margin-top: 18vmin;
      z-index: 195;
    }
  }

  .big {
    max-width: 700px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    @include breakpoint(mobile) {
    }
    .winner {
      width: 50%;
      background-image: url("../assets/images/winners/bg.png");
      background-repeat: no-repeat;
      background-position: center center;
      min-height: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      @include breakpoint(mobile) {
        width: 100%;
      }

      hr {
        width: 110px;
        background: white;
        margin: 12px 0;
        border: 0;
        height: 1px;
      }
      .wrapper {
        position: relative;
        margin-right: 10px;
        &:before {
          background-image: url("../assets/images/winners/1.png");
          width: 62px;
          height: 50px;
          display: block;
          position: absolute;
          left: -4px;
          content: " ";
          @include breakpoint(mobile) {
            width: 71px;
            height: 60px;
            background-size: contain;
            left: -2px;
            background-image: url("../assets/images/winners/1-m.png");
            background-repeat: no-repeat;
          }
        }

      }
      img {
        background-size: cover;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        flex-shrink: 0;
        border: rgba(0, 0, 0, 0.2) solid 2px;
        @include breakpoint(mobile) {
          width: 60px;
          height: 60px;
        }

      }
      .line {
        justify-content: center;
        align-items: center;
        display: flex;

      }
      .name {
        font-size: 18px; /* Приближение из-за подстановки шрифтов */
        font-weight: 700;
        line-height: 20px; /* Приближение из-за подстановки шрифтов */
        text-align: left;
        @include breakpoint(mobile) {
          font-size: 20px;
        }
      }
      .text {
        font-size: 16px; /* Приближение из-за подстановки шрифтов */
        font-weight: 300;
        line-height: 20px; /* Приближение из-за подстановки шрифтов */
        text-align: left;
      }
    }
  }

  .normal {
    max-width: 1000px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    .winner {
      width: 25%;
      min-height: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      @include breakpoint(mobile) {
        width: 100%;
      }
      hr {
        width: 110px;
        background: white;
        margin: 12px 0;
        border: 0;
        height: 1px;
      }
      .wrapper {
        position: relative;
        margin-right: 10px;
        &:before {
          background-image: url("../assets/images/winners/1.png");
          width: 62px;
          height: 50px;
          display: block;
          position: absolute;
          left: -4px;
          content: " ";
          @include breakpoint(mobile) {
            width: 71px;
            height: 60px;
            background-size: contain;
            left: -2px;
            background-image: url("../assets/images/winners/1-m.png");
            background-repeat: no-repeat;
          }
        }

      }
      img {
        background-size: cover;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        flex-shrink: 0;
        border: rgba(0, 0, 0, 0.2) solid 2px;
        @include breakpoint(mobile) {
          width: 60px;
          height: 60px;
        }

      }
      .line {
        justify-content: center;
        align-items: center;
        display: flex;

      }
      .name {
        font-size: 18px; /* Приближение из-за подстановки шрифтов */
        font-weight: 700;
        line-height: 20px; /* Приближение из-за подстановки шрифтов */
        text-align: left;
        @include breakpoint(mobile) {
          font-size: 20px;
        }
      }
      .text {
        font-size: 15px; /* Приближение из-за подстановки шрифтов */
        font-weight: 300;
        line-height: 20px; /* Приближение из-за подстановки шрифтов */
        text-align: left;
      }
    }
  }

  .icon-plane {
    background-image: url("../assets/icons/ico__plane.svg");
    background-repeat: no-repeat;
    margin-right: 9px;
    width: 38px;
    height: 38px;
    background-position: top center;
    background-size: contain;

  }

  .icon-phone {
    background-image: url("../assets/icons/ico__phone.svg");
    background-repeat: no-repeat;
    margin-right: 9px;
    width: 38px;
    height: 38px;
    background-position: top center;
    background-size: contain;

  }

  .icon-doc {
    background-image: url("../assets/icons/ico__doc.svg");
    background-repeat: no-repeat;
    margin-right: 2px;
    width: 60px;
    height: 43px;
    background-position: top center;
    background-size: contain;
  }

  .icon:hover {
    opacity: 1 !important;
  }

  .swiper-container {
    padding-bottom: 70px;
  }
</style>